<template>
  <div class="games-screen">
    <div class="container games-screen__content">
      <ScreenHeader
        class="games-screen__header"
        data-aos="fade-down"
        data-aos-offset="-200"
      >
        <!--        <template #subtitle>-->
        <!--          Explore Our Universe-->
        <!--        </template>-->
        <template #title> {{ title }} </template>
        <template #text> {{ subtitle }} </template>
      </ScreenHeader>
      <div class="games-screen__games">
        <GameCard
          class="games-screen__game-card"
          v-for="(game, i) in featuredGames"
          :key="game.universeId"
          :name="game.displayName"
          :total-visits="game.visits"
          :background-image="game.displayIconUri"
          :current-online="game.playing"
          :genre="game.displayGenre"
          :url-to-play="`https://www.roblox.com/games/${game.rootPlaceId}`"
          data-aos="fade-down"
          :data-aos-delay="i * 100"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  const props = defineProps<{
    title?: string;
    subtitle?: string;
    games: {
      universeId: number;
      name: string;
      displayIconUri: string;
      playing: number;
      visits: number;
      displayGenre: string;
      rootPlaceId: number;
      displayName: string;
    }[];
  }>();

  const GAMES_SCREEN_DEFAULTS = {
    title: "Featured Games",
    subtitle: "Our portfolio includes some of the top games on Roblox.",
    games: [],
  };

  const title = computed(
    () => props.title ?? GAMES_SCREEN_DEFAULTS.title
  );
  const subtitle = computed(
    () => props.subtitle ?? GAMES_SCREEN_DEFAULTS.subtitle
  );
  const featuredGames = computed(
    () =>
      props.games.sort((a, b) => b.playing - a.playing) ??
      GAMES_SCREEN_DEFAULTS.games
  );
</script>

<style lang="scss">
  .games-screen {
    background-image: url("@/assets/images/games-screen-bg.svg");
    background-size: 100% 512px;
    background-position: center top;
    background-repeat: no-repeat;

    padding: 64px 0;

    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 32px;
    }

    &__header {
      max-width: 512px;
    }

    &__games {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 8px;

      width: 100%;

      @media (max-width: $md) {
        flex-direction: column;
      }
    }

    //&__game-card {
    //  flex: 1 0 0;
    //}
  }
</style>
